import { render, staticRenderFns } from "./PhotoTaker.vue?vue&type=template&id=558153c2&scoped=true"
import script from "./PhotoTaker.vue?vue&type=script&lang=ts"
export * from "./PhotoTaker.vue?vue&type=script&lang=ts"
import style0 from "./PhotoTaker.vue?vue&type=style&index=0&id=558153c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558153c2",
  null
  
)

export default component.exports